import { useContext } from 'react';
import { Grid2 as Grid, Avatar, Card, CardContent, CardHeader, Typography, Stack } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { FilersDataContext } from '../../../Filers';
import CoPresentIcon from '@mui/icons-material/CoPresent';

const CandidateInfo = (): JSX.Element => {

    const theme = useTheme();
    const filerDataContext = useContext(FilersDataContext);
    const currentFiler = filerDataContext.currentFilerPayload?.filer;

    return (
        <Grid size={{ xs: 12, md: 5.5 }} data-aos={'fade-up'} marginTop={2}>
          <Card 
            sx={{
              "&:hover": {
                boxShadow: "0 0 10px #ccc",
              },
              borderTop: `2px solid`,
              borderTopColor: blue[700],
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              width: '100%',
              height: '100%',
            }}
            >
            <CardHeader
                avatar={
                <Avatar sx={{ bgcolor: blue[500] }} className="small-avatar">
                    <CoPresentIcon fontSize="small" />
                </Avatar>}
                padding={1}
                title={
                    <Typography
                    variant="h6">
                    Candidate Information
                    </Typography>
                }                                                      
            />                                                   
            <CardContent className="card-content">
                <Grid container spacing={1}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Office/District Sought</Typography>
                      <Typography 
                        variant="subtitle1">
                        {currentFiler?.officeSought.officeDistrict}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Office/District Held</Typography>
                      <Typography 
                        variant="subtitle1"
                        fontWeight={600}>
                        {currentFiler?.officeHeld.officeDistrict}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Stack spacing={0}>
                      <Typography component="i"  variant="subtitle1" color="text.secondary">Candidate Address</Typography>
                      <Typography variant="subtitle1">
                        {currentFiler?.candidate.fullAddress}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>  
            </CardContent>                                               
          </Card>
        </Grid>
    );
  };

export default CandidateInfo;